
import { updateAppConfig } from '#app'
import { defuFn } from '/opt/build/repo/node_modules/defu/dist/defu.mjs'

const inlineConfig = {
  "nuxt": {
    "buildId": "30456f36-0f99-4576-acf6-1246bf754bbe"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/opt/build/repo/app.config.ts"

export default /* #__PURE__ */ defuFn(cfg0, inlineConfig)
